export default __webpack_public_path__ + "static/media/heart.556c78a5.png";